import React, { Component } from 'react';
import i18n from '@i18next/i18n';
import { TOOLBAR_DROPDOWN } from '@src/framework/editor/src/img/pageIndex';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import styles from './template-grid-menu.less';
import { IAddonHandler } from '@src/slide/application/service/addon/addon-handler.interface';

const ISLIDE_ID = '660c4590eea54c509b811c15177dedaf';
const ISLIDE_MARKET_ID = '43zjcji9hfrrtkwijo3fpimafh';

interface IProps {
    handleClickCB: () => void;
}
export default class TemplateImportMenu extends Component<IProps> {
    public constructor(p: IProps) {
        super(p);
        this.state = {
            isMoreDropDownShow: false,
        };
    }

    public render() {
        return <span className={styles.more} onClick={this.onISlideClick} id={'toolbar-import-more'}>
            <span className={styles.moreSpan}>{i18n.t('更多模板')}</span>
            <img className={styles.templateDropIcon} src={TOOLBAR_DROPDOWN}
                style={{ transform: 'rotate(270deg)' }}/>
        </span>;
    }

    private openISlide = async () => {
        this.getAddonManager().addonHandler?.openAddonPanel(this.iSlide?.addonId || '');
    };

    private onISlideClick = async () => {
        if (this.iSlide) {
            this.openISlide();
        } else {
            (this.getAddonManager().addonHandler as IAddonHandler)?.openAddonDetailPanel(ISLIDE_MARKET_ID);
        }
        this.props.handleClickCB?.();
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.MORE_TEMPLATES,
            action: TDWActionType.MORE_TEMPLATES_PLUG_IN,
            ver5: this.iSlide?.name,
        });
    };

    private getAddonManager = () => (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
        .viewableServiceLayer.addonManager;

    private get iSlide() {
        return this.getAddonManager().addonHandler?.addonInfoMap.get(ISLIDE_ID) || null;
    }
}
